import React, { useState, useEffect } from 'react';
import { Image, Container, Row, Col } from "react-bootstrap";
import Navbar from "./Navbar";
import "../css/Header.css";
import { imagePath } from '../Utils/WHL/helpers';

const Header = () => {
    const [logoImage, setLogoImage] = useState('');
    const [isMobile, setIsMobile] = useState(window.innerWidth < 575);
    const [scrollY, setScrollY] = useState(0);
    const [hideNav, setHideNav] = useState(false);

    const handleScreenResize = () => {
        setIsMobile(window.innerWidth < 767);
    };

    const handleScroll = () => {
        // Special case: always show navbar at the top of the page
        if (window.scrollY <= 0) {
            setHideNav(false);
        } else if (window.scrollY > scrollY) {
            setHideNav(true); // Hide navbar on scroll down
        } else {
            setHideNav(false); // Show navbar on scroll up
        }
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        setLogoImage(window.innerWidth > 575 ? 'SunWest-Logo.png' : 'Sun West_White.png');

        window.addEventListener('resize', handleScreenResize);
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('resize', handleScreenResize);
            window.removeEventListener('scroll', handleScroll);
        };
    }, [scrollY]);

    useEffect(() => {
        setLogoImage(isMobile ? 'Sun West_White.png' : 'SunWest-Logo.png');
    }, [isMobile]);

    return (
        <Container 
            fluid 
            className={`logo-only-header px-0 fixed-top ${isMobile && hideNav ? "hide-navbar" : ""}`}
        >
            <Container>
                <Row className="m-0">
                    <Col lg={3} md={3} className="p-0 pl-2 swmc-logo-parent">
                        <div className="d-flex">
                            <a href={process.env.REACT_APP_SWMC_MAIN_SITE} target="_blank">
                                <Image
                                    className="swmc-logo"
                                    width="600"
                                    height="117"
                                    src={`${imagePath}/${logoImage}`}
                                    fluid
                                    alt="Sun West Mortgage Company, Inc. logo"
                                    srcSet={`${imagePath}/${logoImage} 1650w, ${imagePath}/${logoImage} 300w, ${imagePath}/${logoImage} 768w,`}
                                    sizes="(max-width:1650px) 100vw, 1650px"
                                />
                            </a>
                        </div>
                    </Col>
                    <Col className="text-align-right pr-0">
                        <Navbar />
                    </Col>
                </Row>
            </Container>
        </Container>
    );
};

export default Header;